<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     日期选择器
  +---------------------------------------------------------------------------------------
-->

<template>
	<el-date-picker v-model="date" class="f-date-picker" type="date" :picker-options="options" :placeholder="placeholder" :default-value="new Date()" unlink-panels value-format="timestamp" :clearable="clearable" :style="{ width: width + 'px' }" @change="handleChange" />
</template>

<script>
const today = new Date(new Date().toLocaleDateString()).getTime()
export default {
	name: 'FDatePicker',
	props: {
		value: {
			type: Number
		},
		clearable: {
			type: Boolean,
			default: true
		},
		width: {
			type: String,
			default: '160'
		},
		disablerange: {
			type: Array,
			default () {
				return []
			}
		},
		shortcuts: {
			type: Array,
			default () {
				return []
			}
		},
		placeholder: {
			type: String,
			default: '选择日期'
		}
	},
	data () {
		var disabledDate = (date) => {
			if (this.disablerange) {
				if (this.disablerange.length === 1) {
					return date.getTime() < this.disablerange[0] * 1000
				} else {
					return date.getTime() < this.disablerange[0] * 1000 || date.getTime() > this.disablerange[1] * 1000
				}
			} else {
				return false
			}
		}
		const shortcuts = []
		const choices = [
			{ text: '一周前', num: -7 },
			{ text: '一个月前', num: -30 },
			{ text: '三个月前', num: -90 },
			{ text: '六个月前', num: -180 },
			{ text: '六个月前', num: -360 },
			{ text: '昨天', num: -1 },
			{ text: '今天', num: 0 },
			{ text: '明天', num: 1 },
			{ text: '一周后', num: 7 },
			{ text: '一个月后', num: 30 },
			{ text: '三个月后', num: 90 },
			{ text: '六个月后', num: 180 },
			{ text: '六个月后', num: 360 },
		]
		if (this.shortcuts.length > 0) {
			for (const c of choices) {
				if (this.shortcuts.indexOf(c.num) > -1) {
					shortcuts.push({
						text: c.text,
						onClick (picker) {
							let date = today + 3600 * 1000 * 24 * c.num
							picker.$emit('pick', date)
						}
					})
				}
			}
		}
		if (shortcuts.length) {
			return {
				options: {
					shortcuts: shortcuts,
					disabledDate: disabledDate
				}
			}
		} else {
			return {
				options: {
					disabledDate: disabledDate
				}
			}
		}
	},
	computed: {
		date: {
			get () {
				return this.value ? this.value * 1000 : null
			},
			set (val) {
				val = val ? (parseInt(val / 1000) + 86399) : null
				this.$emit('input', val)
			}
		}
	},
	methods: {
		handleChange (val) {
			this.$emit('change', val)
		}
	}
}
</script>

<style lang="scss" slot-scoped>
</style>
